import EU_COUNTRIES from './eu';

const DAC7_COUNTRIES = ['GB', ...EU_COUNTRIES];

export default DAC7_COUNTRIES;
